import { useRef, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setAnsweringQuestionsAction, loadQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setTimeCountAction } from "../../../../redux/answeringQuestions/timeCount";
import createTimer from "../../../../utils/createTimer";

const Timer = ( props ) => {

  const totalAnsweringTimer = useRef();
  const answeringTimer = useRef();
  const timeOverLevel = useRef( 0 );
  const limitTime = useRef( {} );

  const history = useHistory();

  const errorState = useSelector( state => state.errorState );
  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setAnsweringQuestions = useCallback( payload => { dispatch( setAnsweringQuestionsAction( payload ) ) }, [ dispatch ] );
  const loadQuestion = useCallback( payload => { dispatch( loadQuestionAction( payload ) ) }, [ dispatch ] );
  const setTimeCount = useCallback( payload => { dispatch( setTimeCountAction( payload ) ) }, [ dispatch ] );

  useEffect( () => {
    totalAnsweringTimer.current = createTimer( updateTotalAnsweringTime );
    totalAnsweringTimer.current.start();
    answeringTimer.current = createTimer( updateAnsweringTime );
    return () => {
      totalAnsweringTimer.current.clear();
    };
  }, [] );

  const updateTotalAnsweringTime = useCallback( ( time ) => {
    setTimeCount( { totalAnsweringTime : Math.floor( time / 1000 ) } );
  }, [] );

  const updateAnsweringTime = useCallback( ( time ) => {
    const { time1, time2, time3 } = limitTime.current;

    //{time1: 300000 (5분), time2: 840000(14분), time3: 900000(15분)}

    switch ( timeOverLevel.current ) {
      case 0 :
        if ( time1 < time && time2 > time ) {
          timeOverLevel.current++;
          setAnsweringQuestions( {
            timeOverLevel : timeOverLevel.current,
            isShowTimeOverPopup : true
          } );
        }
        break;
      case 1 :
        if ( time2 < time && time3 > time ) {
          timeOverLevel.current++;
          setAnsweringQuestions( {
            timeOverLevel : timeOverLevel.current,
            isShowTimeOverPopup : true
          } );
        }
        break;
      case 2 :
        if ( time3 < time ) {
          answeringTimer.current.pause();
          loadQuestion( { progressCode : TYPE.ANSWERING_QUESTIONS_PROGRESS.SYSTEM_CLOSE } );
          history.goBack();
        }
        break;
    }
    setTimeCount( { answeringTime : time } );
  }, [] );

  useEffect( () => {
    const time1 = answeringQuestions.data.estQstDurMax;
    const time2 = time1 + ( 1000 * 60 * 9 );
    const time3 = time2 + ( 1000 * 60 );
    limitTime.current = { time1, time2, time3 };
  }, [ answeringQuestions.data.estQstDurMax ] );

  useEffect( () => {
    
    if ( answeringQuestions.data.qstCd ) {
      answeringTimer.current.start();
      return () => {
        answeringTimer.current.clear();
        timeOverLevel.current = 0;
        setAnsweringQuestions( { timeOverLevel : timeOverLevel.current } );
      };
    }
  }, [ answeringQuestions.data.qstCd ] );


  // 정답 입력이 변경 될때 마다 (selvas 통신할 때마다) timeout 시간 갱신
  useEffect(() => {
    if (!answeringQuestions?.answer || answeringQuestions.answer.length === 0) return;
    answeringTimer.current.clear()
    answeringTimer.current.start()

    return () => {
      timeOverLevel.current = 0;
      setAnsweringQuestions({ timeOverLevel: timeOverLevel.current });
    };

  }, [answeringQuestions.answer])

  useEffect( () => {
    if ( errorState.isDuplicate ) {
      totalAnsweringTimer.current.clear();
      answeringTimer.current.clear();
    }
  }, [ errorState.isDuplicate ] );

  return props.children || null;

};

export default Timer;
